import styled from "styled-components";

export const TablePageContent = styled.div`
  padding: 0;
  display: flex;
  flex-direction: row;
  position: relative;
  width: 100%;
  flex: 1;
  height: 100%;
  overflow: auto;
`;

export const MainContentWrapper = styled.div`
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1;
  display: flex;
  flex-direction: column;
  .table-with-bulk-action {
    height: 100%;
    overflow: auto;
  }
`;
